import { createSlice } from "@reduxjs/toolkit";

const initialState = localStorage.getItem("categoryActiveTile")
  ? JSON.parse(localStorage.getItem("categoryActiveTile"))
  : {
      categoryIndex: 1,
    };

const categoryActiveTile=createSlice({
    name:"categoryActiveTile",
    initialState,
    reducers:{
        increaseCategoryIndex:(state,active)=>{
            state.categoryIndex=state.categoryIndex+1;
            localStorage.setItem("categoryActiveTile",JSON.stringify(state));
            return state;
        },
        decreaseCategoryIndex:(state,action)=>{
            state.categoryIndex=state.categoryIndex-1;
            localStorage.setItem("categoryActiveTile",JSON.stringify(state));
            return state;
        },
        resetCategoryIndex:(state,action)=>{
            state.categoryIndex=1;
            localStorage.removeItem("categoryActiveTile");
            return state;
        }
    }
})
export const {increaseCategoryIndex,decreaseCategoryIndex,resetCategoryIndex}=categoryActiveTile.actions;
export default categoryActiveTile;